<template>
  <div id="tarana_resources" class="min-vh-100 d-flex flex-column">
    <div class="container-fluid pt-2">
      <div class="row">
        <div class="col-md-12 mb-4 d-block d-md-none">
          <div class="dropdown">
            <button
              class="btn btn-outline-secondary dropdown-toggle text-indigo"
              type="button"
              id="resource-dropdown"
              data-bs-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              {{ dropdownTitleCase() }}
            </button>
            <div class="dropdown-menu" aria-labelledby="resourceDropdown">
              <div
                class="dropdown-item"
                role="presentation"
                @click="gotoLink('all')"
              >
                <div
                  class="card-text ps-3 py-1 cursor-pointer text-indigo"
                  :class="{ active: selectedCategory == 'all' }"
                >
                  All Resources ({{ totalResources }})
                </div>
              </div>
              <div
                class="dropdown-item"
                role="presentation"
                @click="gotoLink('recent')"
              >
                <div
                  class="card-text ps-3 py-1 cursor-pointer text-indigo"
                  :class="{ active: selectedCategory == 'recent' }"
                >
                  Recent Resources ({{ totalRecentResources }})
                </div>
              </div>
              <template
                v-for="(subcategories, category) in categories"
                :key="category"
              >
                <div
                  v-if="subcategories && subcategories.length"
                  class="dropdown-item"
                >
                  <div
                    class="category-disabled text-indigo ps-3"
                    role="presentation"
                  >
                    <b>{{ convertToTitleCase(category) }}</b>
                  </div>
                  <div
                    class="card-text ps-3 py-1 cursor-pointer"
                    v-if="category == 'resourceType'"
                    @click.stop="handleCheckAll"
                  >
                    <div class="form-check">
                      <input
                        type="checkbox"
                        class="form-check-input cursor-pointer"
                        :checked="areAllChecked"
                      />
                      <label
                        class="form-check-label card-text cursor-pointer text-indigo"
                      >
                        {{ areAllChecked ? "Uncheck All" : "Check All" }}
                      </label>
                    </div>
                  </div>
                  <div
                    class="card-text ps-4 py-1"
                    v-for="subcategory in subcategories"
                    :class="{ active: selectedSubcategory == subcategory }"
                    :key="subcategory.id"
                  >
                    <div
                      class="cursor-pointer text-indigo"
                      v-if="category == 'theme'"
                      @click="handleCategoryChange(subcategory)"
                    >
                      {{ convertToTitleCase(subcategory) }} ({{
                        getCountInSubcategory(subcategory, category)
                      }})
                    </div>
                    <div v-else class="form-check">
                      <input
                        type="checkbox"
                        class="form-check-input cursor-pointer"
                        :id="'checkbox-' + subcategory"
                        @click="handleCategoryChange(subcategory)"
                        :checked="resourceCategories.includes(subcategory)"
                      />
                      <label
                        class="form-check-label card-text cursor-pointer text-indigo"
                        @click.stop.prevent
                        @click="handleCategoryChange(subcategory)"
                        :for="'checkbox-' + subcategory"
                      >
                        {{ convertToTitleCase(subcategory) }} ({{
                          getCountInSubcategory(subcategory, category)
                        }})
                      </label>
                    </div>
                  </div>
                </div>
              </template>
            </div>
          </div>
        </div>
        <div class="col-12 col-md-4 col-lg-3 col-xl-2 d-none d-md-block">
          <div class="tarana-sidebar" ref="sidebarContainer">
            <div class="category-list ps-2">
              <div
                class="col-md-12 card-text p-1 border-bottom cursor-pointer"
                :class="{ active: selectedCategory == 'all' }"
                @click="gotoLink('all')"
              >
                All Resources ({{ totalResources }})
              </div>
              <div
                class="col-md-12 card-text p-1 border-bottom cursor-pointer"
                @click="gotoLink('recent')"
                :class="{ active: selectedCategory == 'recent' }"
              >
                Recently Updated ({{ totalRecentResources }})
              </div>
              <div
                v-for="(subcategories, category) in categories"
                :key="category"
                class="category-section"
              >
                <div class="category-main">
                  {{ convertToTitleCase(category) }}
                </div>
                <div v-if="subcategories && subcategories.length">
                  <div
                    class="card-text ps-1 py-1 cursor-pointer"
                    v-if="category == 'resourceType'"
                    @click="handleCheckAll"
                  >
                    <div class="form-check">
                      <input
                        type="checkbox"
                        class="form-check-input cursor-pointer"
                        :checked="areAllChecked"
                      />
                      <label
                        class="form-check-label card-text cursor-pointer"
                      >
                        {{ areAllChecked ? "Uncheck All" : "Check All" }}
                      </label>
                    </div>
                  </div>
                  <div
                    v-for="subcategory in subcategories"
                    :key="subcategory"
                    class="card-text ps-3 py-1 cursor-pointer"
                    :class="{ active: selectedSubcategory == subcategory }"
                    @click="handleCategoryChange(subcategory)"
                  >
                    <span v-if="category == 'theme'"
                      >{{ convertToTitleCase(subcategory) }} ({{
                        getCountInSubcategory(subcategory, category)
                      }})</span
                    >
                    <div class="form-check" v-if="category == 'resourceType'">
                      <input
                        type="checkbox"
                        class="form-check-input cursor-pointer"
                        :id="'checkbox-' + subcategory"
                        :checked="resourceCategories.includes(subcategory)"
                      />
                      <label
                        class="form-check-label card-text cursor-pointer"
                        @click="handleCategoryChange(subcategory)"
                        :for="'checkbox-' + subcategory"
                      >
                        {{ convertToTitleCase(subcategory) }} ({{
                          getCountInSubcategory(subcategory, category)
                        }})
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 col-md-8 col-lg-9 col-xl-10">
          <div class="row" ref="rowContainer" id="resource-row">
            <div class="col-12 mb-4">
              <div class="float-start">
                <h2
                  class="text-left main_head_resource"
                  v-if="themeNames[selectedSubcategory]"
                >
                  {{ themeNames[selectedSubcategory] }}
                </h2>
              </div>
              <div class="float-end">
                <div class="row">
                  <div class="col-9 search-pad">
                    <input
                      type="search"
                      name="title"
                      v-model="searchTitle"
                      class="form-control border border-2"
                      placeholder="Search Resources"
                      @input="resourceSearch"
                    />
                  </div>
                  <div class="col-3 ps-0 search-pad">
                    <button
                      type="button"
                      class="btn clear-button"
                      @click="clearInput"
                    >
                      Reset
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="col-12 mb-4 theme-description"
              v-if="themeDefinitions[selectedSubcategory]"
            >
              <span v-html="$sanitize(themeDefinitions[selectedSubcategory])"></span>
            </div>
            <div
              v-for="(post, index) in top5AllResources"
              :key="post.id"
              class="col mb-4"
              v-if="!selectedSubcategory"
            >
              <div
                class="card card-bg h-100 cursor-pointer"
                @click="gotoPage(post)"
              >
                <div class="position-relative">
                  <img
                    :src="post.image"
                    class="card-img-top"
                    :alt="post.title"
                  />
                </div>
                <div class="card-body">
                  <h4 class="card-title">{{ post.title }}</h4>
                  <div class="badge card-badge">
                    {{ convertToTitleCase(post.canonical_resource_type) }}
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12 mb-4" v-if="top5ThemeResources.length > 0">
              <h2 class="text-left main_head_resource">Top Resources</h2>
            </div>
            <div
              v-if="selectedSubcategory"
              v-for="(post, index) in top5ThemeResources"
              :key="post.id"
              class="col mb-4"
            >
              <div
                class="card card-bg h-100 cursor-pointer"
                @click="gotoPage(post)"
              >
                <div class="position-relative">
                  <img
                    :src="post.image"
                    class="card-img-top"
                    :alt="post.title"
                  />
                </div>
                <div class="card-body">
                  <h4 class="card-title">{{ post.title }}</h4>
                  <div class="badge card-badge">
                    {{ convertToTitleCase(post.canonical_resource_type) }}
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12" v-for="(item, category) in resourceCards">
              <div class="card card-tile mb-4" v-if="item.length">
                <div class="card-header">
                  {{ convertToTitleCase(category) }}
                </div>
                <div class="card-body p-0">
                  <ul class="list-group list-group-flush">
                    <li
                      class="list-group-item"
                      v-for="resource in item.slice(
                        0,
                        resourcesShown[category]
                      )"
                      :key="resource.id"
                    >
                      <div class="py-2 card-text">
                        <a
                          :href="resource.link"
                          target="_blank"
                          class="resource-title"
                          @click="resourceAction(resource)"
                          ><font-awesome-icon
                            :icon="['fa', checkLinkType(resource)]"
                            class="pad-right"
                          />{{ resource.title }}
                        </a>
                        <span
                          class="resource-date"
                          v-if="resource.revision_date"
                          >{{ formatDate(resource.revision_date) }}</span
                        ><span
                          class="badge resource-badge"
                          v-if="isRecentlyUpdated(resource.revision_date)"
                          >Recently Updated</span
                        ><br />
                        <div class="mt-2">
                          <span class="fw-700" v-html="$sanitize(resource.description)">
                          </span>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
                <div
                  class="card-footer text-center"
                  v-if="resourcesShown[category] < item.length"
                  @click="loadMore(category)"
                >
                  Load More
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      posts: [],
      loadCount: 10,
      totalResources: 0,
      totalRecentResources: 0,
      totalThemeCount: [],
      selectedCategory: "all",
      selectedSubcategory: "",
      sidebarHeight: 0,
      rowHeight: 0,
      recentResources: [],
      resourceList: [],
      filterResources: [],
      filterResourceCategories: [],
      filterIds: [],
      resourceCards: [],
      categories: [],
      resourceDataForFilter: [],
      recentResourceForFilter: [],
      resourceCategories: [],
      top5ThemeResources: [],
      top5AllResources: [],
      resourcesShown: {},
      themeNames: {},
      themeDefinitions: {},
      resourceTypeOrders: {},
      urlResourceType: "",
      searchTitle: "",
      areAllChecked: false,
      isSearchValid: false,
      showClear: false,
    };
  },
  computed: {
    currentUser() {
      return this.$store.state.auth.user;
    },
  },
  methods: {
    clearInput() {
      this.searchTitle = "";
      this.showClear = false;
      this.getMainSiteResources();
    },
    getHubspotUTK() {
      const cookies = document.cookie.split(";");
      for (let cookie of cookies) {
        const [key, value] = cookie.trim().split("=");
        if (key === "hubspotutk") {
          return value;
        }
      }
      return null; // Return null if not found
    },
    getHubSpotUTKFromUrl() {
      const urlParams = new URLSearchParams(window.location.search);
      return urlParams.get("hubspotutk");
    },
    resourceAction(resource) {
      const platform = process.env.VUE_APP_PLATFORM;
      let eventName = "pe20495833_viewed_resource___test___mode";
      if (this.$store.state.auth.settings["hubspot-tracking-mode"] == "live") {
        eventName = "pe20495833_view_resource_v3";
      }
      if (platform === "production" && window._hsq) {
        window._hsq.push([
          "trackCustomBehavioralEvent",
          {
            name: eventName,
            properties: {
              resource_id: resource.id,
              resource_name: resource.title,
            },
          },
        ]);
        this.sendHubspotRequest(resource);
      }
    },
    async sendHubspotRequest(resource) {
      const hubspotUTK = this.getHubspotUTK();
      let objectType = "2-38634177";
      if (this.$store.state.auth.settings["hubspot-tracking-mode"] == "live") {
        objectType = "2-38350111";
      }
      const customObjectType = objectType;

      if (customObjectType) {
        const HS_API = process.env.VUE_APP_HUBSPOT_API_BASE;
        const endpoints = {
          fetchContact:           `https://api.hubapi.com/contacts/v1/contact/utk/${hubspotUTK}/profile`,
          contactSearch:          `${HS_API}/objects/contacts/search`,
          contactCreate:          `${HS_API}/objects/contacts`,
          customObjectCreate:     `${HS_API}/objects/${customObjectType}`,
          associateObjectToContact: `${HS_API}/associations/${customObjectType}/contacts/batch/create`,
        };

        const createCustomObject = (contactEmail, contactId) => {
          const createObjectPayload = {
            properties: {
              resource_id: resource.id,
              resource_name: resource.title,
              contact_email: contactEmail || "Unknown User",
              hubspotutk: hubspotUTK,
            },
          };

          const createObjectRequest = {
            post_url: endpoints.customObjectCreate,
            json_data: createObjectPayload,
          };

          if (this.currentUser) {
            createObjectRequest.session_id = this.currentUser.sessionId;
          }

          return this.$axios.post("hubspot-request", createObjectRequest);
        };

        const createContact = (email) => {
          const createContactPayload = { properties: { email: email } };
          const createContactRequest = {
            post_url: endpoints.contactCreate,
            json_data: createContactPayload,
          };

          return this.$axios.post("hubspot-request", createContactRequest);
        };

        const searchContactByEmail = (email) => {
          const searchContactPayload = {
            filterGroups: [
              {
                filters: [
                  {
                    propertyName: "email",
                    operator: "EQ",
                    value: email,
                  },
                ],
              },
            ],
          };

          const searchContactRequest = {
            post_url: endpoints.contactSearch,
            json_data: searchContactPayload,
          };

          return this.$axios.post("hubspot-request", searchContactRequest);
        };

        const fetchContactByUTK = async () => {
          const fetchContactRequest = { post_url: endpoints.fetchContact };
          return this.$axios.post("hubspot-request", fetchContactRequest);
        };

        const processContact = async () => {
          try {
            let contactId = null;
            let contactEmail = "Unknown User";

            // Step 1: Check if current user exists
            if (this.currentUser) {
              contactEmail = this.currentUser.user.email;

              // Search for contact by email
              const searchResponse = await searchContactByEmail(contactEmail);
              if (searchResponse?.data?.results?.length) {
                contactId = searchResponse.data.results[0].id;
              } else {
                // Create contact if not found
                const newContactResponse = await createContact(contactEmail);
                contactId = newContactResponse?.data?.id;
              }
            } else {
              // Step 2: If current user doesn't exist, fetch contact using hubspotUTK
              const contactResponse = await fetchContactByUTK();
              contactId = contactResponse?.data?.vid || null;
              contactEmail =
                contactResponse?.data?.properties?.email?.value ||
                "Unknown User";

              if (!contactId && contactEmail != "Unknown User") {
                // Create a new contact with the fetched email or default
                const newContactResponse = await createContact(contactEmail);
                contactId = newContactResponse?.data?.id;
              }
            }

            const customObjectResponse = await createCustomObject(
              contactEmail,
              contactId
            );
            const customObjectId = customObjectResponse?.data?.id;

            if (customObjectId && contactId) {
              // Associate Custom Object with Contact
              let associationType = "contact_to_viewed_resource___test___mode";
              if (
                this.$store.state.auth.settings["hubspot-tracking-mode"] ==
                "live"
              ) {
                associationType = "contact_to_viewed_resources";
              }
              const associationPayload = {
                inputs: [
                  {
                    from: { id: customObjectId },
                    to: { id: contactId },
                    type: associationType,
                  },
                ],
              };
              const associateRequest = {
                post_url: endpoints.associateObjectToContact,
                json_data: associationPayload,
              };
              this.$axios.post("hubspot-request", associateRequest);
            } else {
              console.error("Failed to create custom object.");
            }
          } catch (error) {
            console.error("Error processing contact:", error);
          }
        };

        processContact();
      }
    },
    resourceSearch() {
      this.isSearchValid = this.searchTitle != "" ? true : false;
      if (this.isSearchValid) {
        if (this.searchTitle.length > 2) {
          if (this.selectedCategory != "all") {
            this.filterBySubcategory("all");
          }
          this.$axios
            .post("resources-search", { search: this.searchTitle })
            .then(
              function (response) {
                let filtered = response.data;
                this.filterIds = [];
                if (filtered.length > 0) {
                  filtered.forEach((post) => {
                    if (!this.filterIds.includes(post.id)) {
                      this.filterIds.push(post.id);
                    }
                  });
                }
                this.filterAllResources();
              }.bind(this)
            );
        }
      } else {
        this.getMainSiteResources();
      }
    },
    filterAllResources() {
      this.filterResources = [];
      this.resourceList = [];
      this.totalResources = 0;

      let filtered = {};
      let filteredCategories = [];
      this.filterPostsData();
      if (this.selectedSubcategory) {
        this.resourceList[this.selectedSubcategory] = [];
      }

      let total = 0;
      for (const type of this.filterResourceCategories) {
        if (this.resourceDataForFilter[type]) {
          filtered[type] = this.resourceDataForFilter[type].filter((resource) =>
            this.filterIds.includes(parseInt(resource.id))
          );
          if (this.selectedSubcategory) {
            this.resourceList[this.selectedSubcategory][type] = filtered[type];
          }
          if (filtered[type].length) {
            total = total + filtered[type].length;
            filteredCategories.push(type);
          }
        }
      }
      if (!this.selectedSubcategory) {
        this.totalResources = total;
      } else {
        this.totalThemeCount[this.selectedSubcategory] = total;
      }
      this.resourceCategories = filteredCategories;
      this.resourceDataForFilter = filtered;
      this.filterResources = this.resourceDataForFilter;
      this.areAllChecked =
        this.resourceCategories.length ===
        this.categories["resourceType"].length;
      this.getAllResources();
    },
    filterResourceData(subcat) {
      if (subcat) {
        const index = this.resourceCategories.indexOf(subcat);
        if (index !== -1) {
          this.resourceCategories.splice(index, 1);
        } else {
          this.resourceCategories.push(subcat);
        }
      }

      this.areAllChecked =
        this.resourceCategories.length ===
        this.categories["resourceType"].length;

      const filterData = this.resourceCategories.reduce((acc, cat) => {
        acc[cat] = { ...this.resourceDataForFilter[cat] };
        return acc;
      }, {});

      this.filterResources = { ...filterData };
      this.getAllResources();
    },
    formatDate(dateString) {
      const date = new Date(dateString)
        .toLocaleDateString("en-US", {
          timeZone: "UTC",
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
        })
        .replace(/\//g, ".");
      return date;
    },
    checkLinkType(post) {
      let linkType = "link";
      const resourceTypeFiles = ["white-papers", "data-sheets"];
      const resourceTypeVideos = ["videos", "webinars"];
      if (resourceTypeVideos.includes(post.canonical_resource_type)) {
        linkType = "video";
      } else if (resourceTypeFiles.includes(post.canonical_resource_type)) {
        linkType = "file";
      }
      return linkType;
    },
    gotoPage(resource) {
      this.resourceAction(resource);
      window.open(resource.link, "_blank");
    },
    gotoLink(canonical) {
      let newUrl = "/tarana-resources";
      const queryParams = new URLSearchParams();

      // Add hubspotutk if present in current route
      if (this.$route.query.hubspotutk) {
        queryParams.set("hubspotutk", this.$route.query.hubspotutk);
      }

      // Build hash
      let hash = canonical;
      if (
        !["all", "recent"].includes(canonical) &&
        this.selectedCategory === "recent"
      ) {
        hash = `recent&${canonical}`;
      }

      // Append query string if present
      if (Array.from(queryParams).length > 0) {
        newUrl += `?${queryParams.toString()}`;
      }

      // Append hash
      newUrl += `#${hash}`;

      // Navigate
      window.location.href = newUrl;

      // Reload if needed
      if (this.urlResourceType === "" || this.selectedSubcategory !== "") {
        location.reload();
      }
    },
    getMainSiteResources() {
      let loader = this.$loading.show({
        canCancel: true,
        color: "#0367a9",
      });
      this.$axios.get("resources-json", {}).then(
        function (response) {
          loader.hide();
          this.themeNames = response.data.theme_names ?? {};
          this.themeDefinitions = response.data.theme_definitions;
          this.resourceTypeOrders = response.data.resource_type_listing_order;
          this.posts = response.data.resources;
          this.totalResources = this.posts.length;
          this.filterPostsData();
        }.bind(this)
      );
    },
    filterPostsData() {
      this.recentResources = [];
      this.resourceList = [];
      this.filterResources = [];
      this.categories = {
        theme: [],
        resourceType: [],
      };
      this.categoryResources = [];
      this.resourceDataForFilter = [];
      this.recentResourceForFilter = [];
      this.resourceCategories = [];
      let themeCount = [];
      let recentThemeCount = [];
      let grouped = {};
      let groupedRecent = {};
      let resourceIds = [];
      let recentResourceIds = [];
      this.posts.forEach((post) => {
        // Iterate over each theme of the resource
        post.canonical_themes.forEach((themeObj) => {
          const theme = themeObj.theme;
          const resourceType = post.canonical_resource_type;
          themeCount[theme] = (themeCount[theme] || 0) + 1;

          if (!groupedRecent[theme]) {
            groupedRecent[theme] = {};
          }

          if (!grouped[theme]) {
            grouped[theme] = {};
            this.categories.theme.push(theme);
            this.categoryResources[theme] = [];
          }

          if (!this.resourceDataForFilter[resourceType]) {
            this.resourceDataForFilter[resourceType] = [];
          }

          if (!this.recentResourceForFilter[resourceType]) {
            this.recentResourceForFilter[resourceType] = [];
          }

          if (!grouped[theme][resourceType]) {
            grouped[theme][resourceType] = [];
            this.categoryResources[theme].push(resourceType);
          }

          grouped[theme][resourceType].push(post);

          if (!groupedRecent[theme][resourceType]) {
            groupedRecent[theme][resourceType] = [];
          }

          if (
            !resourceIds.includes(post.id) &&
            this.selectedSubcategory == ""
          ) {
            this.resourceDataForFilter[resourceType].push(post);
            resourceIds.push(post.id);
          }

          if (this.isRecentlyUpdated(post.revision_date)) {
            recentThemeCount[theme] = (recentThemeCount[theme] || 0) + 1;
            groupedRecent[theme][resourceType].push(post);

            if (!recentResourceIds.includes(post.id)) {
              this.recentResourceForFilter[resourceType].push(post);
              recentResourceIds.push(post.id);
              this.recentResources.push(post);
            }
          }

          if (
            !this.categories.resourceType.includes(resourceType) &&
            this.selectedSubcategory == ""
          ) {
            this.categories.resourceType.push(resourceType);
            this.resourceCategories.push(resourceType);
          }
        });
      });
      this.totalThemeCount = themeCount;
      if (this.selectedCategory == "recent") {
        this.totalThemeCount = recentThemeCount;
        this.resourceList = groupedRecent;
        this.resourceDataForFilter = this.recentResourceForFilter;
      } else {
        this.resourceList = grouped;
      }
      this.totalRecentResources = this.recentResources.length;
      if (this.selectedSubcategory) {
        let category = this.selectedSubcategory;
        this.categories.resourceType = [];
        this.categories.resourceType = this.categoryResources[category];
        this.resourceCategories = Object.values(
          this.categoryResources[category]
        );
        this.resourceDataForFilter = this.resourceList[category];
      } else {
        this.resourceDataForFilter = { ...this.resourceDataForFilter };
      }

      // Sort resource types based on resource type order
      this.categories.resourceType.sort((a, b) => {
        const orderA = this.getResourceTypeOrder(a);
        const orderB = this.getResourceTypeOrder(b);
        return orderA - orderB;
      });

      this.areAllChecked = true;
      this.filterResourceCategories = this.resourceCategories;
      this.filterResources = this.resourceDataForFilter;
      if (this.urlResourceType != "") {
        this.resourceCategories = [];
        if (this.urlResourceType.includes(",")) {
          this.resourceCategories = this.urlResourceType.split(",");
        } else {
          this.resourceCategories.push(this.urlResourceType);
        }
        this.filterResourceData();
      }
      this.getAllResources();
    },
    getResourceTypeOrder(type) {
      const orderEntry = this.resourceTypeOrders.find(
        (entry) => entry.type === type
      );
      return orderEntry ? orderEntry.order : this.resourceTypeOrders.length + 1;
    },
    dropdownTitleCase() {
      if (this.selectedSubcategory) {
        return (
          this.convertToTitleCase(this.selectedSubcategory) +
          " (" +
          this.getCountInSubcategory(this.selectedSubcategory, "theme") +
          ")"
        );
      } else if (this.selectedCategory === "all") {
        return "All Resources (" + this.totalResources + ")";
      } else {
        return "Recent Resources (" + this.totalRecentResources + ")";
      }
    },
    convertToTitleCase(str) {
      if (!str) {
        return this.top5AllResources.length > 0 ? "Top Resources" : "";
      } else if (str == "theme") {
        return "Themes";
      } else if (str == "resourceType") {
        return "Resource Types";
      } else if (this.themeNames[str]) {
        return this.themeNames[str];
      } else {
        return str
          .split("-")
          .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
          .join(" ");
      }
    },
    getCountInSubcategory(subcategory, maincategory) {
      if (this.selectedSubcategory != "" && maincategory == "resourceType") {
        return this.resourceList[this.selectedSubcategory][subcategory].length;
      } else if (maincategory == "theme") {
        return this.totalThemeCount[subcategory] ?? 0;
      } else {
        return this.resourceDataForFilter[subcategory].length;
      }
    },
    getAllResources() {
      const dataArray = Object.keys(this.filterResources).map((key) => ({
        type: key,
        ...this.filterResources[key],
      }));

      dataArray.sort((a, b) => {
        const orderA = this.getResourceTypeOrder(a.type);
        const orderB = this.getResourceTypeOrder(b.type);
        return orderA - orderB;
      });

      this.resourceCards = [];
      this.top5ThemeResources = [];
      this.top5AllResources = [];
      let top5RecentAllResources = [];
      let top5RecentResources = [];
      let tarana_resources = [];
      Object.keys(dataArray).forEach((maincategory) => {
        var dataobj = dataArray[maincategory];
        tarana_resources[dataobj.type] = [];
        let resource_ids = [];
        Object.keys(dataobj).forEach((subcatname) => {
          if (
            dataobj[subcatname].top5_all_resources == "true" &&
            this.selectedSubcategory == ""
          ) {
            if (!resource_ids.includes(dataobj[subcatname].id)) {
              this.top5AllResources.push(dataobj[subcatname]);
              resource_ids.push(dataobj[subcatname].id);
              if (this.isRecentlyUpdated(dataobj[subcatname].revision_date)) {
                top5RecentAllResources.push(dataobj[subcatname]);
              }
            }
          }
          if (
            dataobj[subcatname].canonical_themes &&
            this.selectedSubcategory != ""
          ) {
            dataobj[subcatname].canonical_themes.forEach((theme) => {
              if (
                theme.top5 == "true" &&
                this.selectedSubcategory == theme.theme
              ) {
                this.top5ThemeResources.push(dataobj[subcatname]);
                if (this.isRecentlyUpdated(dataobj[subcatname].revision_date)) {
                  top5RecentResources.push(dataobj[subcatname]);
                }
              }
            });
          }
          if (dataobj[subcatname] != dataobj.type) {
            tarana_resources[dataobj.type].push(dataobj[subcatname]);
          }
        });
      });

      if (this.selectedCategory == "recent") {
        this.top5AllResources = top5RecentAllResources;
        this.top5ThemeResources = top5RecentResources;
      }

      // Sort resources by revision_date in descending order
      if (this.top5AllResources.length > 0) {
        this.top5AllResources.sort(
          (a, b) => new Date(b.revision_date) - new Date(a.revision_date)
        );
      }

      if (this.top5ThemeResources.length > 0) {
        this.top5ThemeResources.sort(
          (a, b) => new Date(b.revision_date) - new Date(a.revision_date)
        );
      }

      Object.keys(tarana_resources).forEach((type) => {
        tarana_resources[type].sort((a, b) => {
          return new Date(b.revision_date) - new Date(a.revision_date);
        });
      });
      this.resourceCards = { ...tarana_resources };

      // Add or update this logic at the end of getAllResources:
      Object.keys(this.resourceCards).forEach((cat) => {
        if (!this.resourcesShown[cat]) {
          // Use preserved value if present, otherwise init with loadCount
          this.resourcesShown[cat] = Math.min(
            this.loadCount,
            this.resourceCards[cat].length
          );
        } else if (this.resourcesShown[cat] > this.resourceCards[cat].length) {
          // If filtering reduces count, don't show more than available
          this.resourcesShown[cat] = this.resourceCards[cat].length;
        }
      });

      // Optionally, clean up categories that no longer exist:
      Object.keys(this.resourcesShown).forEach((cat) => {
        if (!this.resourceCards[cat]) {
          delete this.resourcesShown[cat];
        }
      });

      this.handleResize();
    },
    loadMore(category) {
      if (!this.resourceCards[category]) return;
      const total = this.resourceCards[category].length;
      const current = this.resourcesShown[category] ?? this.loadCount;
      const next = Math.min(current + this.loadCount, total);
      this.resourcesShown[category] = next;
      this.handleResize();
    },
    handleCheckAll() {
      this.areAllChecked = !this.areAllChecked;
      this.resourceCategories = this.areAllChecked
        ? [...this.categories["resourceType"]]
        : [];
      this.filterResourceData();
    },
    handleCategoryChange(subcategory) {
      if (this.categories.theme.includes(subcategory)) {
        this.gotoLink(subcategory);
      } else {
        this.filterResourceData(subcategory);
      }
    },
    filterBySubcategory(canonical) {
      if (canonical == "all" || canonical == "recent") {
        this.selectedCategory = canonical;
        this.selectedSubcategory = "";
      } else {
        this.selectedSubcategory = canonical;
      }
      this.getMainSiteResources();
    },
    isRecentlyUpdated(revDate) {
      const days = parseInt(process.env.VUE_APP_CORPORATE_RECENT_DAYS) || 30;

      const pastDate = new Date();
      pastDate.setDate(pastDate.getDate() - days);

      const updatedDate = new Date(revDate);

      const utcPastDate = new Date(
        Date.UTC(
          pastDate.getFullYear(),
          pastDate.getMonth(),
          pastDate.getDate()
        )
      );

      const utcUpdatedDate = new Date(
        Date.UTC(
          updatedDate.getFullYear(),
          updatedDate.getMonth(),
          updatedDate.getDate()
        )
      );

      return utcUpdatedDate >= utcPastDate;
    },
    handleResize() {
      this.$nextTick(this.getRowHeight);
    },
    getRowHeight() {
      // Accessing the div element using the ref
      const sidebarElement = this.$refs.sidebarContainer;
      if (sidebarElement) {
        this.sidebarHeight = sidebarElement.offsetHeight;
      }

      const rowElement = this.$refs.rowContainer;
      if (rowElement) {
        this.rowHeight = rowElement.offsetHeight;
      }
      let pageHeight = document.body.scrollHeight;

      window.parent.postMessage(
        {
          type: "contentLoaded",
          height: pageHeight,
          row_height: this.rowHeight,
          sidebar_height: this.sidebarHeight,
          canonical_main: this.selectedCategory,
          canonical: this.selectedSubcategory,
        },
        "*"
      );
    },
  },
  created() {
    try {
      if (this.$route.query.type) {
        this.urlResourceType = this.$route.query.type;
      }
      var currentURL = this.$route.hash;
      if (currentURL) {
        var queryString = window.location.hash.substring(1);
        const urlParts = queryString.split("?");
        if (urlParts.length > 0) {
          var hashValue = urlParts[0];
          var urlCategory = urlParts[0].split("&");
          if (urlCategory[0] == "recent") {
            this.selectedCategory = "recent";
            hashValue = urlCategory[1] ? urlCategory[1] : urlCategory[0];
          }
        }
        this.urlResourceType = urlParts[1]
          ? urlParts[1].split("=")[1].replace(/%20/g, "")
          : "";
        if (hashValue) {
          this.filterBySubcategory(hashValue);
        } else {
          this.filterBySubcategory("all");
        }
      } else {
        this.filterBySubcategory("all");
      }
    } catch (error) {
      this.filterBySubcategory("all");
    }
    window.addEventListener("resize", this.handleResize);
  },
  beforeDestroy() {
    // Remove the resize event listener when the component is destroyed
    window.removeEventListener("resize", this.handleResize);
  },
};
</script>
